export default ['imgix', 'configService', function (imgix, configService) {
    return {
        restrict: 'A',
        scope: {
            url: '@imgixSrc'
        },
        link: function ($scope, element, attrs) {
            let imgixBaseUrl = configService.get('imgix.source');
            let uploadBaseUrl = configService.get('uploadsBaseUrl');

            let fit = '';
            switch (attrs.fit) {
                case 'fit':
                    fit = 'fit=clip';
                    break;

                case 'crop':
                    fit = 'fit=crop';
                    break;

                default:
                case 'auto':
                    fit = 'fit=crop&crop=faces,edges';
                    break;
            }
            let imgixQuery = `?auto=format&ch=DPR,Width&q=65&${fit}`;
            let dataSrc = '';

            if (uploadBaseUrl && imgixBaseUrl) {
                let decodedSrc = decodeURIComponent(attrs.imgixSrc);
                if (decodedSrc.indexOf('//') === 0) {
                    dataSrc = 'https:';
                } else if (uploadBaseUrl.indexOf('http') === 0 && decodedSrc.indexOf('//') !== 0) {
                    dataSrc = 'https://';
                }
                dataSrc += decodedSrc.replace(uploadBaseUrl, imgixBaseUrl) + imgixQuery;
                element.attr('data-src', dataSrc).addClass('imgix-fluid');
            } else {
                dataSrc += attrs.imgixSrc;
                if (element[0].tagName === 'IMG') {
                    element.attr('src', dataSrc);
                } else {
                    element.attr('style', `background-image: url("${dataSrc}")`).addClass('no-imgix');
                }
            }
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/directives/imgixSrc.directive.js